import {SetProperties} from "@/models/SetProperties";

export class AddressGarParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(AddressGar.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, AddressGar.build(item))
  }

  remove(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => AddressGar.build(el))
    }
    return this
  }
}

export class AddressGar extends SetProperties{
  constructor() {
    super()
    this.id = null
    this.addressType = null
    this.addressCells = []
    this.fullAddress = null
    this.flat = null
    this.houseRef = null
    this.postalCode = null
    this.country = null
    this.personalData = null
    this.theSame = false
  }

  getForAPI() {
    return {
      id: this.id,
      addressType: this.addressType,
      addressCells: this.addressCells,
      fullAddress: this.fullAddress,
      flat: this.flat,
      houseRef: this.houseRef,
      postalCode: this.postalCode,
      country: this.country,
      personalData: this.personalData,
      theSame: this.theSame,
    }
  }

  static build(obj) {
    const _this = new AddressGar()
    if (obj) {
      _this.id = obj.id
      _this.addressType = obj.addressType
      _this.addressCells = obj.addressCells
      _this.fullAddress = obj.fullAddress
      _this.flat = obj.flat
      _this.houseRef = obj.houseRef
      _this.postalCode = obj.postalCode
      _this.country = obj.country
      _this.personalData = obj.personalData
      _this.theSame = obj.theSame
    }
    return _this
  }
}
